import script from "./AIChatMessagesPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AIChatMessagesPage.vue?vue&type=script&setup=true&lang=ts"

import "./AIChatMessagesPage.vue?vue&type=style&index=0&id=2102c5ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2102c5ce"]])

export default __exports__